import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

// General
import Holidays from "./Tabs/general/holidays.js";
import InternalRemake from "./Tabs/general/internalRemake/internalremake";
import NextCase from "./Tabs/general/nextCase/nextCase.js";
import ShippingTypes from './Tabs/general/shipping/ShippingTypes';
import MappingRules from './Tabs/general/mapping/MappingRules';
import Locations from './Tabs/general/location/Locations';
// Procedure
import LabProcedure from './Tabs/procedures/labprocedure/LabProcedure';
import DisplayCategories from './Tabs/procedures/DisplayCate';
import CaseEnclosures from './Tabs/procedures/enclosure/CaseEnclosures';
// Attributes
import AcrylicColors from './Tabs/attributes/AcrylicColor/AcrylicColors';
import ImplantMarkers from './Tabs/attributes/ImplantMarkers/implantMarkers';
import ImplantSystems from './Tabs/attributes/ImplantSystems/implantsystems';
import CaseMaterials from './Tabs/attributes/MaterialorAlloy/CaseMaterials';
import OrthodonticColors from './Tabs/attributes/OrthodonticColors/OrthodonticColors';
import OrthodonticDesigns from './Tabs/attributes/OrthodonticDesigns/OrthodonticDesigns';
import SpotGurd from './Tabs/attributes/spotgurd/spotgurd';
import SystemAttributes from './Tabs/attributes/SystemAttributes';
import CustomAttributes from './Tabs/attributes/CustomAttributes';

const CaseSetting = () => {
  const location = useLocation();
  const [activeButton, setActiveButton] = useState("General");
  const [activeGeneralTab, setActiveGeneralTab] = useState("Shipping Types");
  const [activeProcedureTab, setActiveProcedureTab] = useState("Lab Procedures");
  const [activeAttributeTab, setActiveAttributeTab] = useState("materials");
  const [hasError, setHasError] = useState(false);

  // Define the order of general tabs and which ones should be disabled
  const generalTabs = [
    { key: "Scheduling/Holidays", title: "Scheduling/Holidays", component: Holidays },
    { key: "Internal Remake Types", title: "Internal Remake Types", component: InternalRemake },
    { key: "Next-case Types", title: "Next-case Types", component: NextCase },
    { key: "Shipping Types", title: "Shipping Types", component: ShippingTypes },
    { key: "Mappings", title: "Mappings", component: MappingRules },
    { key: "Locations", title: "Locations", component: Locations }
  ];

  const shippingTypesIndex = generalTabs.findIndex(tab => tab.key === "Shipping Types");

  useEffect(() => {
    if (location.state?.activeSection && location.state?.activeTab) {
      setActiveButton(location.state.activeSection);
      if (location.state.activeSection === "General") {
        setActiveGeneralTab(location.state.activeTab);
      } else if (location.state.activeSection === "Procedures") {
        setActiveProcedureTab(location.state.activeTab);
      } else if (location.state.activeSection === "Attributes") {
        setActiveAttributeTab(location.state.activeTab);
      }
    } else {
      // Set default to Shipping Types when page first loads
      setActiveGeneralTab("Shipping Types");
    }
  }, [location.state]);

  // Error boundary effect to catch errors from child components
  useEffect(() => {
    const handleError = (error) => {
      console.error('Error in child component:', error);
      setHasError(true);
    };

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  const disabledLinks = ["Store", "Permission Groups", "Finances"];
  const isDisabled = (name) => disabledLinks.includes(name);

  // Function to check if a general tab should be disabled
  const isGeneralTabDisabled = (tabKey) => {
    const tabIndex = generalTabs.findIndex(tab => tab.key === tabKey);
    return tabIndex < shippingTypesIndex;
  };

  if (hasError) {
    return (
      <>
        <div style={{ marginBottom: "25px" }}>

        </div>
        <div style={{ width: "95%", margin: "0 auto", padding: "20px" }}>
          <div className="alert alert-danger" role="alert">
            <h4>Something went wrong</h4>
            <p>There was an error loading the component. Please try refreshing the page.</p>
            <button 
              className="btn btn-primary" 
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div style={{ marginBottom: "25px" }}>

      </div>
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          
          <div className="col-md-10">
            <h1 style={{ marginBottom: "20px" }}>Case Settings</h1>
            <div
              className="title"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              <button
                style={{
                  backgroundColor: activeButton === "General" ? "#004aad" : "",
                  border: "none",
                  color: activeButton === "General" ? "white" : "black",
                  borderRadius: "4px",
                  padding: "10px",
                  margin: "0 10px",
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                }}
                onClick={() => setActiveButton("General")}
              >
                General
              </button>
              <span style={{ margin: "0 10px" }}></span>
              <button
                style={{
                  backgroundColor: activeButton === "Procedures" ? "#004aad" : "",
                  border: "none",
                  color: activeButton === "Procedures" ? "white" : "black",
                  borderRadius: "4px",
                  padding: "10px",
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                }}
                onClick={() => setActiveButton("Procedures")}
              >
                Procedures
              </button>
              <span style={{ margin: "0 10px" }}></span>
              <button
                style={{
                  backgroundColor: activeButton === "Attributes" ? "#004aad" : "",
                  border: "none",
                  color: activeButton === "Attributes" ? "white" : "black",
                  borderRadius: "4px",
                  padding: "10px",
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                }}
                onClick={() => setActiveButton("Attributes")}
              >
                Attributes
              </button>
            </div>

            {/* Error boundary for tabs */}
            <div>
              {activeButton === "General" && (
                <Tabs
                  activeKey={activeGeneralTab}
                  onSelect={(k) => {
                    // Only allow selection of non-disabled tabs
                    if (!isGeneralTabDisabled(k)) {
                      setActiveGeneralTab(k);
                    }
                  }}
                  id="general-tabs"
                  className="mb-3"
                >
                  {generalTabs.map((tab) => {
                    const TabComponent = tab.component;
                    return (
                      <Tab
                        key={tab.key}
                        eventKey={tab.key}
                        title={tab.title}
                        disabled={isGeneralTabDisabled(tab.key)}
                      >
                        <div className="tab-content-wrapper">
                          <TabComponent />
                        </div>
                      </Tab>
                    );
                  })}
                </Tabs>
              )}
              {activeButton === "Procedures" && (
                <Tabs
                  activeKey={activeProcedureTab}
                  onSelect={(k) => setActiveProcedureTab(k)}
                  id="procedures-tabs"
                  className="mb-3"
                >
                  <Tab eventKey="Lab Procedures" title="Lab Procedures">
                    <div className="tab-content-wrapper">
                      <LabProcedure />
                    </div>
                  </Tab>
                  <Tab eventKey="Display Categories" title="Display Categories">
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                  <Tab eventKey="Tasks" title="Tasks" disabled>
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                  <Tab eventKey="Departments" title="Departments" disabled>
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                  <Tab eventKey="Components" title="Components" disabled>
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                  <Tab eventKey="Enclosures" title="Enclosures" disabled>
                    <div className="tab-content-wrapper">
                      <CaseEnclosures />
                    </div>
                  </Tab>
                  <Tab eventKey="Specified Files" title="Specified Files" disabled>
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                  <Tab eventKey="Revenue Centers" title="Revenue Centers" disabled>
                    <div className="tab-content-wrapper">
                      <DisplayCategories />
                    </div>
                  </Tab>
                </Tabs>
              )}
              {activeButton === "Attributes" && (
                <Tabs
                  activeKey={activeAttributeTab}
                  onSelect={(k) => setActiveAttributeTab(k)}
                  id="attributes-tabs"
                  className="mb-3"
                >
                  <Tab eventKey="materials" title="materials">
                    <div className="tab-content-wrapper">
                      <CaseMaterials />
                    </div>
                  </Tab>
                  <Tab eventKey="acrylic-colors" title="acrylic-colors">
                    <div className="tab-content-wrapper">
                      <AcrylicColors />
                    </div>
                  </Tab>
                  <Tab eventKey="sport-guard-colors" title="sport-guard-colors">
                    <div className="tab-content-wrapper">
                      <SpotGurd />
                    </div>
                  </Tab>
                  <Tab eventKey="Implant Systems" title="Implant Systems">
                    <div className="tab-content-wrapper">
                      <ImplantSystems />
                    </div>
                  </Tab>
                  <Tab eventKey="Implant Markers" title="Implant Markers">
                    <div className="tab-content-wrapper">
                      <ImplantMarkers />
                    </div>
                  </Tab>
                  <Tab eventKey="orthodontic-colors" title="orthodontic-colors">
                    <div className="tab-content-wrapper">
                      <OrthodonticColors />
                    </div>
                  </Tab>
                  <Tab eventKey="orthodontic-designs" title="orthodontic-designs">
                    <div className="tab-content-wrapper">
                      <OrthodonticDesigns />
                    </div>
                  </Tab>
                  <Tab eventKey="system-attributes" title="system-attributes">
                    <div className="tab-content-wrapper">
                      <SystemAttributes />
                    </div>
                  </Tab>
                  <Tab eventKey="custom-attributes" title="custom-attributes">
                    <div className="tab-content-wrapper">
                      <CustomAttributes />
                    </div>
                  </Tab>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "50px" }}>

      </div>
    </>
  );
};

export default CaseSetting